<template>
  <div class="relative">
    <TButton
      :inverse="inverse"
      @click="open = !open"
      class="w-8 h-8"
      tooltip="Insert emoji"
    >
      <template #icon>
        <AddEmoji />
      </template>
    </TButton>
    <Picker
      v-if="open"
      ref="emoji-picker"
      :data="emojiIndex"
      native
      :showPreview="false"
      style="position: absolute; top: 100%; right: 0; z-index: 1000"
      :emojiSize="20"
      color="var(--c-accent-1)"
      :pickerStyles="{
        background: inverse ? 'var(--c-g10)' : 'var(--c-g800)',
        border: '2px solid var(--c-accent-1)',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        color: inverse ? 'var(--c-g800)' : 'var(--c-g50)',
      }"
      @select="select"
    />
  </div>
</template>
<script setup lang="ts">
import { AddEmoji } from "@topol/icons";
import { TButton } from "@topol/twig-ui";
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";
import { onClickOutside } from "@vueuse/core";
import { Editor } from "@tiptap/core";
import { ref, useTemplateRef } from "vue";

const props = defineProps<{
  editor: Editor;
  inverse?: boolean;
}>();

const open = ref(false);

const emojiIndex = new EmojiIndex(data);
const emojiPicker = useTemplateRef("emoji-picker");

onClickOutside(emojiPicker, () => {
  open.value = false;
});

const bgColor = props.inverse ? "var(--c-g10)" : "var(--c-g800)";
const textColor = props.inverse ? "var(--c-g800)" : "var(--c-g50)";
const textHoverColor = props.inverse ? "var(--c-g300)" : "var(--c-g100)";
const bgHoverColor = props.inverse
  ? "color-mix(in srgb,var(--c-g100) 50%,var(--c-g10))"
  : "var(--c-g600)";

function select(emoji: { native: string }) {
  props.editor.chain().focus().insertContent(emoji.native).run();
  open.value = false;
}
</script>

<style lang="scss">
.emoji-mart-category-label h3 {
  background-color: v-bind(bgColor) !important;
  color: v-bind(textColor) !important;
}
.emoji-mart-emoji,
.emoji-mart-emoji span {
  cursor: pointer !important;
  &:hover {
    background-color: v-bind(bgHoverColor) !important;
  }
}
.emoji-mart-emoji:hover:before {
  background-color: v-bind(bgHoverColor) !important;
}
.emoji-mart-anchor {
  color: v-bind(textColor) !important;
  cursor: pointer;
  &:hover {
    color: v-bind(textHoverColor) !important;
  }
}
.emoji-mart-anchor-selected {
  color: var(--c-accent-1) !important;
}
</style>
